<template>
    <div class="news-page">
        <div class="container">
            <div class="page-title" >
                <h1>
                    <span v-if="globalLang == ''">НОВОСТИ</span>
                    <span v-if="globalLang == 'kz/'">ЖАҢАЛЫҚТАР</span>
                    <span v-if="globalLang == 'en/'">NEWS</span>
                </h1>
            </div>
            <newsItems></newsItems>
            <transition
                name="fade"
                mode="out-in"
            >
                <div class="btn-pagination" v-if="!hidePaginBtn">
                    <a href="#" @click.prevent="paginationNews">Загрузить еще</a>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import newsItems from '@/components/news-page/news-item.vue'
    import store from '@/store.js'
    // import salesFilter from '@/components/realestate/sales-filter.vue'
    export default {
        name: 'news--page',
        components: {
            newsItems,
        },
        data () {
            return {
                count: 9,
                page: 1,
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            pageSetup: 'loadNewsPage',
            newsPageCount: 'loadNewsPageCount',
            hidePaginBtn: 'loadHidePaginBtn',
        }),
        methods: {
            paginationNews() {
                // this.count = this.count + 2;
                this.$parent.$refs.topProgress.start()
                this.page = this.page + 1;
                if (this.page < this.newsPageCount) {
                    this.ajaxInit();
                } else if (this.page == this.newsPageCount) {
                    this.ajaxInit();
                }

                if (this.page >= this.newsPageCount) {
                   this.$store.commit('HidePaginBtn', true); 
                }
               
               
                // console.log(this.count, 'NEWS')
            },
            ajaxInit() {
                axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/news?per_page=' + this.count + '&page=' + this.page).then(async (response) => {
                    // console.log(response)
                    this.$store.commit('newsItems', response.data);
                    this.$parent.$refs.topProgress.done()
                });
            }
        },
        beforeRouteEnter (to, from, next) {
            if (store.state.newsItems.length > 0) {
                next(vm => {
                    // store.dispatch('getNewsPageData');
                    vm.$parent.$refs.topProgress.done();
                    vm.$store.commit('removePageLoaderImg');
                });
            } else {
                // store.dispatch('getNewsPageData');
                store.dispatch('getNewsItems').then((response) => {
                    // console.log(response, 'how to by')
                    if (response) {
                        next(vm => {
                            vm.$parent.$refs.topProgress.done();
                            vm.$store.commit('removePageLoaderImg');
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
            // this.$store.dispatch('getNewsPageData');
            // this.$store.dispatch('getNewsItems');
            document.body.dataset.page = 'news';
        },
        created () {
            // document.title = this.titlePage + ' - ' + this.titleSite;
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/news-page/news-page.scss';
    @import '@/styles/components/news-page/respond/news-page-respond.scss';
</style>